import { cn } from "../../lib/utils.js";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/illustrations/Bricks.tsx
const Bulldozer = ({ className, ...props }) => /* @__PURE__ */ jsxs("svg", {
	width: "111",
	height: "109",
	viewBox: "0 0 111 109",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	className: cn("tw:w-[111px] tw:h-[109px]", className),
	...props,
	children: [/* @__PURE__ */ jsxs("g", {
		clipPath: "url(#clip0_376_2474)",
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M90.27 24.11L90.23 37.81L81.74 46.45L81.78 32.75L90.27 24.11Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M81.78 32.7499L81.74 46.4499L47.92 35.2699L47.96 21.5699L81.78 32.7499Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M90.27 24.1101L81.78 32.7501L47.96 21.5701L56.44 12.9301L90.27 24.1101Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M60.36 55.26L72.77 48.1L72.76 35.27L60.36 42.43V55.26Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M60.36 55.26L32.97 39.4L32.98 26.58L60.36 42.43V55.26Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M72.76 35.27L60.36 42.43L32.98 26.58L45.49 19.42L72.76 35.27Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M44.13 64.74L56.54 57.58L56.53 44.75L44.13 51.91V64.74Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M44.13 64.7401L16.74 48.8801L16.75 36.0601L44.13 51.9101V64.7401Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M56.53 44.75L44.13 51.91L16.75 36.06L29.26 28.9L56.53 44.75Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M27.89 73.94L40.3 66.7699L40.29 53.95L27.89 61.11V73.94Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M27.89 73.94L0.5 58.08L0.51 45.26L27.89 61.11V73.94Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M40.29 53.95L27.89 61.11L0.51001 45.26L13.02 38.1L40.29 53.95Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M67.84 37.6801L80.26 30.5101L80.24 17.6801L67.84 24.8401V37.6801Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M67.8399 37.68L40.45 21.81L40.47 8.98999L67.8399 24.84V37.68Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M80.24 17.68L67.84 24.84L40.47 8.98996L52.98 1.82996L80.24 17.68Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M51.47 47.12L63.88 39.95L63.87 27.13L51.47 34.29V47.12Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M51.47 47.1199L24.08 31.2599L24.09 18.4399L51.47 34.2899V47.1199Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M63.87 27.13L51.47 34.29L24.09 18.44L36.6 11.28L63.87 27.13Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M35.13 56.4399L47.55 49.2799L47.54 36.45L35.13 43.61V56.4399Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M35.13 56.44L7.75 40.58L7.76 27.76L35.13 43.61V56.44Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M47.54 36.45L35.13 43.61L7.76001 27.76L20.27 20.6L47.54 36.45Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M81.51 84.75L69.09 77.58L69.11 64.76L81.51 71.92V84.75Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M81.51 84.7499L108.9 68.8899L108.88 56.0699L81.51 71.9199V84.7499Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M69.11 64.76L81.51 71.92L108.88 56.07L96.38 48.91L69.11 64.76Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M75.57 94.08V107.69L67.78 98.7V85.09L75.57 94.08Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M110.24 83.74V97.35L75.5699 107.69V94.08L110.24 83.74Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M75.57 94.08L67.78 85.09L102.45 74.76L110.24 83.74L75.57 94.08Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M56.06 18.9L56.02 32.6L42.01 38.34L42.05 24.65L56.06 18.9Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M42.05 24.65L42.01 38.34L19.48 19.94L19.52 6.23999L42.05 24.65Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M56.06 18.9L42.05 24.65L19.52 6.24L33.54 0.5L56.06 18.9Z",
				fill: "white",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", {
		id: "clip0_376_2474",
		children: /* @__PURE__ */ jsx("rect", {
			width: "111",
			height: "109",
			fill: "white"
		})
	}) })]
});
//#endregion
export { Bulldozer as default };

//# sourceMappingURL=Bricks.js.map